<template>
    <div class="form__field">
        <label v-if="label" :for="label">
            {{ label }}
            <span v-if="required" class="required-mark">*</span>
        </label>
        <input
            :id="label"
            :name="name"
            v-bind="$attrs"
            :placeholder="placeholder"
            :value="modelValue"
            @input="updateValue"
            :required="required"
            :aria-required="required"
        >
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        label: {
            type: String
        },
        name: {
            type: String
        },
        modelValue: {
            type: String
        },
        placeholder: {
            type: String,
            default: ''
        },
        required: {
            type: Boolean,
            default: false
        }
    },

    setup(props, context) {
        const updateValue = (event: Event) => {
            context.emit('update:modelValue', (event.target as HTMLInputElement).value);
        }

        return {
            label: props.label,
            updateValue,
            required: props.required
        }
    }
})

</script>

<style scoped>
.required-mark {
    color: #FF3434;
    margin-left: 4px;
}
</style>
